import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Likes',
          path: 'likes',
          component: () => import('@/views/dashboard/likes/Likes'),
        },
        {
          name: 'PortfolioList',
          path: 'portfolio/list',
          component: () => import('@/views/dashboard/portfolio/PortfolioList'),
        },
        {
          name: 'PortfolioAdd',
          path: 'portfolio/add',
          component: () => import('@/views/dashboard/portfolio/PortfolioModify'),
        },
        {
          name: 'PortfolioModify',
          path: 'portfolio/modify/:id',
          props: true,
          component: () => import('@/views/dashboard/portfolio/PortfolioModify'),
        },
        {
          name: 'PortfolioModifyNoProps',
          path: 'portfolio/modify',
          component: () => import('@/views/dashboard/portfolio/PortfolioModify'),
        },        
        {
          /*path: 'portfolio/analyze',
          redirect: '/portfolio/list'*/
          name: 'PortfolioAnalyzeNoProps',
          path: 'portfolio/analyze',
          component: () => import('@/views/dashboard/portfolio/PortfolioList'),          
        },
        {
          name: 'PortfolioAnalyze',
          path: 'portfolio/analyze/:id',
          props: true,
          component: () => import('@/views/dashboard/portfolio/PortfolioAnalyze'),
        },
        {
          name: 'PortfolioPositioning',
          path: 'portfolio/positioning',
          component: () => import('@/views/dashboard/portfolio/PortfolioPositioning'),
        },
        {
          name: 'StocksList',
          path: 'stocks/list',
          component: () => import('@/views/dashboard/stocks/StocksList'),
        },
        {
          /*path: 'stocks/analyze',
          redirect: '/stocks/list'*/
          name: 'StocksAnalyzeNoProp',
          path: 'stocks/analyze',
          component: () => import('@/views/dashboard/stocks/StocksList'),          
        },
        {
          name: 'StocksAnalyze',
          path: 'stocks/analyze/:stock',
          props: true,
          component: () => import('@/views/dashboard/stocks/StocksAnalyze'),
        },
        {
          name: 'StocksSelect',
          path: 'stocks/select',
          component: () => import('@/views/dashboard/stocks/StocksSelect'),
        },
        {
          name: 'InvestorsList',
          path: 'investors/list',
          component: () => import('@/views/dashboard/investors/InvestorsList'),
        },
        {
          /*path: 'investors/analyze',
          redirect: '/investors/list'*/
          name: 'InvestorsAnalyzeNoProp',
          path: 'investors/analyze',
          component: () => import('@/views/dashboard/investors/InvestorsList'),          
        },
        {
          name: 'InvestorsAnalyze',
          path: 'investors/analyze/:investor',
          props: true,
          component: () => import('@/views/dashboard/investors/InvestorsAnalyze'),
        },
        {
          name: 'InvestorsPositioning',
          path: 'investors/positioning',
          component: () => import('@/views/dashboard/investors/InvestorsPositioning'),
        },
        {
          name: 'MarketFlows',
          path: 'market/flows',
          component: () => import('@/views/dashboard/market/MarketFlows'),
        },
        {
          name: 'MarketStrategy',
          path: 'market/backtesting',
          component: () => import('@/views/dashboard/market/MarketStrategy'),
        },        
        {
          name: 'MarketTracker',
          path: 'market/tracker',
          component: () => import('@/views/dashboard/market/MarketTracker'),
        },
        {
          name: 'PeerGroupList',
          path: 'peergroup/list',
          component: () => import('@/views/dashboard/peergroup/PeerGroupList'),
        }, 
        {
          name: 'PeerGroupAdd',
          path: 'peergroup/add',
          component: () => import('@/views/dashboard/peergroup/PeerGroupModify'),
        }, 
        {
          name: 'PeerGroupModifyNoProp',
          path: 'peergroup/modify',
          component: () => import('@/views/dashboard/peergroup/PeerGroupModify'),
        }, 
        {
          name: 'PeerGroupModify',
          path: 'peergroup/modify/:id',
          props: true,
          component: () => import('@/views/dashboard/peergroup/PeerGroupModify'),
        },
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login'),
        },
      ],
      meta: { requiresAuth: false }
    },
    {
      path: '*',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          path: "*",
          component: () => import('@/views/dashboard/NotFound'),
        },
      ],
      meta: { requiresAuth: false }      

    },    
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }  
})

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
      next()
    } catch (e) {
      next({
        path: '/login'
      })
    }
  }
  next()
})

export default router